import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { class: "mb-10" }
const _hoisted_3 = { class: "bg-white rounded-lg border border-gray-300" }
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { class: "my-5" }
const _hoisted_6 = { class: "gap-7" }
const _hoisted_7 = { class: "mt-2" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "mt-2" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "flex justify-end" }
const _hoisted_12 = { class: "flex flex-col mt-4" }
const _hoisted_13 = { class: "my-4 gap-2" }
const _hoisted_14 = { class: "mb-4" }
const _hoisted_15 = { class: "flex justify-end gap-3 mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("h4", _hoisted_1, _toDisplayString(_ctx.$t("labels.generic", {
          pt: "Engajamento de alunos",
          en: "Student engagement",
        })), 1),
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Table, {
          class: "mb-80",
          actions: _ctx.actions,
          columns: _ctx.columns,
          slotData: _ctx.data,
          loading: _ctx.loading,
          hasStatus: false,
          rows: _ctx.params.perPage,
          totalRecords: _ctx.params.total,
          params: _ctx.params,
          onOnGoTo: _ctx.openModal,
          onOnPaginate: _ctx.paginate,
          onOnFilter: _ctx.applyFilter,
          actionsTitle: 
            _ctx.$t('labels.generic', { pt: 'Detalhes', en: 'Details' })
          
        }, {
          filters: _withCtx(() => [
            (_ctx.filterType === 'user_name')
              ? (_openBlock(), _createBlock(_component_InputText, {
                  key: 0,
                  modelValue: _ctx.filters.search,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.search) = $event)),
                  placeholder: 
                _ctx.$t('labels.generic', {
                  pt: 'Filtrar por nome',
                  en: 'Filter by name',
                })
              ,
                  class: "w-full",
                  onInput: _ctx.onFilterChange
                }, null, 8, ["modelValue", "placeholder", "onInput"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["actions", "columns", "slotData", "loading", "rows", "totalRecords", "params", "onOnGoTo", "onOnPaginate", "onOnFilter", "actionsTitle"])
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showDetails,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showDetails) = $event)),
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '40vw' },
      class: "custom-modal",
      modal: true
    }, {
      header: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checked, (item, index) => {
          return (_openBlock(), _createElementBlock("h5", { key: index }, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Informações do aluno -",
                en: "Student information -",
              })), 1),
            _createTextVNode(" " + _toDisplayString(item.value), 1)
          ]))
        }), 128))
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Sobre:",
                en: "About:",
              })), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info, (item, index) => {
              return (_openBlock(), _createElementBlock("p", { key: index }, [
                _createElementVNode("strong", null, _toDisplayString(item.name) + ":", 1),
                _createTextVNode(" " + _toDisplayString(item.value), 1)
              ]))
            }), 128)),
            _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Curso:",
                en: "Course:",
              })), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.course, (item, index) => {
              return (_openBlock(), _createElementBlock("p", { key: index }, [
                _createElementVNode("strong", null, _toDisplayString(item.name) + ":", 1),
                _createTextVNode(" " + _toDisplayString(item.value) + " ", 1),
                (item.subtitle !== undefined)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                      _createElementVNode("i", {
                        class: _normalizeClass([[
                  'pi',
                  item.subtitle > 0
                    ? 'pi-chevron-up text-green-500'
                    : item.subtitle < 0
                    ? 'pi-chevron-down text-red-500'
                    : 'pi-minus text-gray-500',
                ], "ml-2 align-middle"])
                      }, null, 2)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            _createElementVNode("h5", _hoisted_9, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Dados Matemáticos:",
                en: "Mathematical Data:",
              })), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.math, (item, index) => {
              return (_openBlock(), _createElementBlock("p", { key: index }, [
                _createElementVNode("strong", null, _toDisplayString(item.name) + ":", 1),
                _createTextVNode(" " + _toDisplayString(item.value) + " ", 1),
                (item.subtitle !== undefined)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                      _createElementVNode("i", {
                        class: _normalizeClass([[
                  'pi',
                  item.subtitle > 0
                    ? 'pi-chevron-up text-green-500'
                    : item.subtitle < 0
                    ? 'pi-chevron-down text-red-500'
                    : 'pi-minus text-gray-500',
                ], "ml-2 align-middle"])
                      }, null, 2)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_Button, {
            onClick: _ctx.openStats,
            label: "Avaliar estimativa",
            icon: "pi pi-check",
            iconPos: "right",
            class: "btn-outline"
          }, null, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showStats,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showStats) = $event)),
      header: "Confirmar correção",
      class: "custom-modal",
      modal: true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Status atual de verificação de dados:",
                  en: "Current data verification status:",
                })), 1),
              _createVNode(_component_InputText, {
                disabled: "",
                class: "w-full",
                modelValue: _ctx.selectedRowStatus,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedRowStatus) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Selecione a avaliação para os dados:",
                  en: "Select the assessment for the data:",
                })), 1),
              _createVNode(_component_Dropdown, {
                class: "!border-h-primary-800 !border w-full",
                optionLabel: "name",
                options: _ctx.engageOptions,
                modelValue: _ctx.selectedDropdownValue,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedDropdownValue) = $event))
              }, null, 8, ["options", "modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_Button, {
              label: "Confirmar",
              icon: "pi pi-check",
              class: "btn-simple",
              onClick: _ctx.updateData
            }, null, 8, ["onClick"]),
            _createVNode(_component_Button, {
              label: "Cancelar",
              icon: "pi pi-times",
              onClick: _ctx.closeStats,
              class: "btn-delete"
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}